// extracted by mini-css-extract-plugin
module.exports = {"login_btn":"index-module__login_btn___Ymdis","join_btn":"index-module__join_btn___P090x"};